export class CapturedImage{
    constructor(id, source) {
      this.id = id;
      this.source = source;
    }
  }